<template>
    <div class='threeText'>
        <span class="text" :style="{'color':control.color,'font-size':control.fontSize+'px','font-weight':control.bold}">{{control.text}}</span>
    </div>
</template>

<script>
export default {
    name:"threeText",
    props:{
        control:{
            type:Object,
            default:()=>{
                return {
                    text:"文字信息"
                }
            }
        }
    }
}
</script>

<style lang='less' scoped>
    .threeText{
        .text{
            color: #000;font-size: 16px;
        }
    }
</style>